import React, {useEffect, useState} from 'react';


export const ChangeOrderArrows = ({
  index,
  isFirst,
  isLast,
  srOnlySuffix,
  getContentAlert,
  onMoveDown,
  onMoveUp,
}) => {
  const [alertContent, setAlertContent] = useState(null);
  const [alertTimeout, setAlertTimeout] = useState(null);

  useEffect(() => {
    // don't destroy component without alert cleaning
    return () => {
      if (alertTimeout) {
        clearTimeout(alertTimeout);
        setAlertTimeout(null);
      }
    }
  }, []);

  function handleMoveDown(ev) {
    setAlertContent(getContentAlert(index, index + 1));
    const timeout = setTimeout(() => {
      setAlertContent(null);
      setAlertTimeout(null);
    }, 3000);
    setAlertTimeout(timeout);

    onMoveDown(ev);
  }

  function handleMoveUp(ev) {
    setAlertContent(getContentAlert(index, index - 1));
    const timeout = setTimeout(() => {
      setAlertContent(null);
      setAlertTimeout(null);
    }, 3000);
    setAlertTimeout(timeout);

    onMoveUp(ev);
  }

  return (
    <div className="order-icons">
      <button
        className="btn m-0 v-btn v-btn--disabled v-btn--icon"
        disabled={isFirst}
        type="button"
        onClick={handleMoveUp}
      >
        <div className="v-btn__content">
          <i aria-hidden='true' className="v-icon material-icons">arrow_upward</i>
        </div>
        {!isFirst && <span className="sr-only">Przesuń w górę {srOnlySuffix}</span>}
      </button>
      <button
          className="btn m-0 v-btn v-btn--disabled v-btn--icon"
          disabled={isLast}
          type="button"
          onClick={handleMoveDown}
      >
        <div className="v-btn__content">
          <i aria-hidden='true' className="v-icon material-icons">arrow_downward</i>
        </div>
        {!isLast && <span className="sr-only">Przesuń w dół {srOnlySuffix}</span>}
      </button>
      {alertContent && <span className="sr-only" role="alert">{alertContent}</span>}
    </div>
  )
};
